import { Component, Input, Inject, OnChanges, signal } from '@angular/core';
import { DateOptions, DATE_OPTIONS, AuctionsWalletItem } from '@fgb/core';
import { DateTime } from 'luxon';

@Component({
  selector: 'fgbcl-auction-won-list-item',
  templateUrl: './auction-won-list-item.component.html',
  styleUrls: ['./auction-won-list-item.component.scss'],
})
export class AuctionWonListItemComponent implements OnChanges {
  @Input() auctionItem: AuctionsWalletItem;
  @Input() orientation: 'landscape' | 'portrait' = 'portrait';
  @Input() redeemed: boolean = false;
  @Input() showButton: boolean = true;
  expired = signal(false);

  constructor(@Inject(DATE_OPTIONS) public dateOption: DateOptions) {}

  ngOnChanges(): void {
    const isExpired = DateTime.fromISO(this.auctionItem.ExpireDate as string, { zone: 'utc' }) < DateTime.utc();
    this.expired.set(isExpired);
  }
}
